
export { default as PersonSuitIcon } from "./PersonSuit.js"